import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Phone = createSvgIcon(
  () => (
    <path d="M18.332 1.12891L14.6758 0.285156C14.2891 0.179688 13.8672 0.390625 13.6914 0.777344L12.0039 4.71484C11.8633 5.06641 11.9688 5.45312 12.25 5.69922L14.3945 7.45703C13.1289 10.1289 10.9141 12.3789 8.17188 13.6797L6.41406 11.5352C6.16797 11.2539 5.78125 11.1484 5.42969 11.2891L1.49219 12.9766C1.10547 13.1523 0.929688 13.5742 1 13.9609L1.84375 17.6172C1.94922 18.0039 2.26562 18.25 2.6875 18.25C11.6875 18.25 19 10.9727 19 1.9375C19 1.55078 18.7188 1.23438 18.332 1.12891Z" />
  ),
  '0 0 19 19'
);
